import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout'; // 引入 Layout 组件
import './UserManagementPage.css';
import '../resource/common.js'

const host = process.env.REACT_APP_API_HOST; // API 地址

function UserManagementPage() {
    const [users, setUsers] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        axios
            .get(`${host}/api/admin/users`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
                setUsers(response.data);
            })
            .catch((err) => {
                setError('Failed to fetch users. Please try again later.');
                console.error(err);
            });
    }, []);

    const handleApprove = (userId) => {
        const token = localStorage.getItem('token');
        axios
            .put(
                `${host}/api/admin/users/${userId}/approve`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(() => {
                setUsers((prevUsers) =>
                    prevUsers.map((user) =>
                        user.id === userId ? { ...user, role: 9 } : user
                    )
                );
            })
            .catch((err) => {
                console.error(err);
                alert('Failed to approve user.');
            });
    };

    const handleDelete = (userId) => {
        const token = localStorage.getItem('token');
        axios
            .delete(`${host}/api/admin/users/${userId}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then(() => {
                setUsers((prevUsers) =>
                    prevUsers.map((user) =>
                        user.id === userId ? { ...user, role: -9 } : user
                    )
                );
            })
            .catch((err) => {
                console.error(err);
                alert('Failed to delete user.');
            });
    };

    const handleForbid = (userId) => {
        const token = localStorage.getItem('token');
        axios
            .put(
                `${host}/api/admin/users/${userId}/forbidden`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(() => {
                setUsers((prevUsers) =>
                    prevUsers.map((user) =>
                        user.id === userId ? { ...user, role: -2 } : user
                    )
                );
            })
            .catch((err) => {
                console.error(err);
                alert('Failed to forbid user.');
            });
    };

    const action_map = userMgmt_action_map;

    const handleMgmt = (userId, action) => {
        const token = localStorage.getItem('token');
        axios
            .post(
                `${host}/api/admin/users/${userId}`,
                { action: action }, // 请求体包含 action
                { headers: { Authorization: `Bearer ${token}` } } // 请求头包含 Authorization
            )
            .then(() => {
                setUsers((prevUsers) =>
                    prevUsers.map((user) =>
                        user.id === userId ? { ...user, role: action_map[action] } : user
                    )
                );
            })
            .catch((err) => {
                console.error(err);
                alert(`Failed to execute action: ${action} \n` + (err.response?.data?.error || ''));
            });
    };

    return (
        <Layout>
            <div className="user-management-container">
                <h1>User Management</h1>
                {error && <p className="error-message">{error}</p>}
                <table className="user-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Username</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr key={user.id}>
                                <td>{user.id}</td>
                                <td>{user.username}</td>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>{user.role === 0 ? 'Super' : user.role === 1 ? 'Admin' : user.role === -1 ? 'Pending' : user.role === -9 ? 'Forbidden' : user.role === -99 ? 'Deleted' : 'User'}</td>
                                <td>
                                    {user.role !== 0 && (
                                        <div>
                                            <button onClick={() => handleMgmt(user.id,'approve')}>Approve</button>
                                            <button onClick={() => handleMgmt(user.id,'delete')}>Delete</button>
                                            <button onClick={() => handleMgmt(user.id,'forbid')}>Forbid</button>
                                            <button onClick={() => handleMgmt(user.id,'setAdmin')}>setAdmin</button>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Layout>
    );
}

export default UserManagementPage;